import { getCurrentLocale, getRawRequest } from '../../../../../../../../../../../../utils'

export type ContactAccountStatementFormat = 'csv' | 'html' | 'pdf' | 'xlsx'

const CONTACT_ACCOUNT_STATEMENT_MIME: Record<ContactAccountStatementFormat, string> = {
  csv: 'text/csv',
  html: 'text/html',
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export interface FetchContactAccountStatementParams {
  contactId: string
  format: ContactAccountStatementFormat
  organizationId: string
  period?: string
}

export const fetchContactAccountStatement = ({
  contactId,
  format,
  organizationId,
  period,
}: FetchContactAccountStatementParams): Promise<Response> => {
  const query = period ? `?${new URLSearchParams({ period })}` : ''

  return getRawRequest(
    `/v2/organizations/${organizationId}/contacts/${contactId}/contactAccountStatement.${format}${query}`,
    {
      Accept: CONTACT_ACCOUNT_STATEMENT_MIME[format],
      'accept-language': getCurrentLocale(),
    },
  )
}
